/* eslint-disable react/no-unused-prop-types */
import { Typography, TypographyHTMLProps, TypographyT } from "@rmwc/typography"
import "@rmwc/typography/styles"
import omit from "lodash/omit"
import { styled, StyleProps, CSSFn, callCSSFn } from "../styles"

interface Props {
  use?: TypographyT
  css?: CSSFn
}

export type TextProps = TypographyHTMLProps & Props

const TextComponent = (props: TextProps) => {
  const { use, ...rest } = omit(props, `css`)
  return <Typography {...{ use: use || `body1`, ...rest }} />
}

TextComponent.defaultProps = {
  use: `body1`,
  css: undefined,
}

export const Text = styled(TextComponent)((props: StyleProps & TextProps) => ({
  margin: 0,
  "-webkit-font-smoothing": `auto`,
  "-moz-osx-font-smoothing": `auto`,
  ...callCSSFn(props),
}))
